import { render, staticRenderFns } from "./youtubeGallery.vue?vue&type=template&id=f0098bc2"
import script from "./youtubeGallery.vue?vue&type=script&lang=js"
export * from "./youtubeGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports